import { Sparkles, Gamepad, HardDrive, Cpu, Laptop } from "lucide-react";

const PRICING = [
  { icon: Sparkles, name: "General Cleaning", price: "$30", note: "+ tax", desc: "Full deep-clean of fans, vents, heatsinks. Restore airflow and quiet down loud consoles.", accent: "#0055FF", featured: true },
  { icon: Gamepad, name: "Controller Repair", price: "$30", note: "flat", desc: "Stick drift, dead buttons, broken triggers. Most controllers turned around same day.", accent: "#34C759" },
  { icon: HardDrive, name: "SSD / HDD Replacement", price: "Quote", note: "parts at cost", desc: "HDD → SSD upgrades for laptops & PCs. Massive speed boost, usually under $100 in labor.", accent: "#0055FF" },
  { icon: Cpu, name: "PC Repair", price: "Quote", note: "in-person", desc: "Diagnostics, GPU swaps, PSU & fan replacements, full rebuilds. Drop off in Susquehanna.", accent: "#FFCC00" },
  { icon: Laptop, name: "Laptop Repair", price: "Quote", note: "make/model", desc: "Quote depends on model and parts. Common: SSDs, RAM, batteries, screens, fans.", accent: "#0055FF" },
];

export default function Pricing() {
  return (
    <section id="pricing" className="relative py-24 sm:py-32 border-t border-white/5 bg-[#0A0A0A]" data-testid="pricing-section">
      <div className="absolute inset-0 grid-bg opacity-30 pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 sm:px-8">
        <div className="mb-16">
          <div className="font-mono text-xs tracking-[0.25em] uppercase text-zinc-500 mb-4">
            [ 02 ] · TRANSPARENT PRICING
          </div>
          <h2 className="font-display font-bold text-4xl sm:text-5xl lg:text-6xl tracking-tighter mb-4">
            Flat rates. <span className="text-zinc-500">No bullshit.</span>
          </h2>
          <p className="text-zinc-400 max-w-2xl leading-relaxed">
            What you see is what you pay. PC and laptop work is quoted after diagnostic — you
            always approve the price before any tools come out.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {PRICING.map((p) => {
            const Icon = p.icon;
            return (
              <div
                key={p.name}
                className={`tech-card relative bg-[#121212] border rounded-md p-8 ${
                  p.featured ? "border-[#FFCC00]/40" : "border-zinc-800"
                }`}
                data-testid={`pricing-card-${p.name.toLowerCase().replace(/\s+/g, '-')}`}
              >
                {p.featured && (
                  <div className="absolute -top-2 right-6 px-2 py-1 bg-[#FFCC00] text-black font-mono text-[10px] tracking-[0.2em] uppercase rounded-sm">
                    Most popular
                  </div>
                )}
                <Icon className="w-6 h-6 mb-6" style={{ color: p.accent }} />
                <div className="flex items-baseline gap-2 mb-2">
                  <span className="font-display font-bold text-4xl tracking-tighter">{p.price}</span>
                  <span className="font-mono text-xs text-zinc-500 uppercase">{p.note}</span>
                </div>
                <h3 className="font-display font-semibold text-lg mb-3">{p.name}</h3>
                <p className="text-zinc-400 text-sm leading-relaxed">{p.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
